module.exports = __webpack_public_path__ + "img/4.194a7cf9.jpg";